import { WrapperLoading } from "@src/shared/components/WrapperLoading/WrapperLoading";
import { UpdateUserForm } from "@src/features/updateUserInfo";
import { useGetUserInfoMe } from "@src/entities/user";

import styles from "./PersonalCabinet.module.scss";

export function PersonalCabinet() {
    const { isPending, isError } = useGetUserInfoMe();
  
  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>Личный кабинет</h1>
      <div className={styles.content}>
        <WrapperLoading isLoading={isPending} isError={isError}>
          <UpdateUserForm />
        </WrapperLoading>
      </div>
    </div>
  );
}
